module.exports = __webpack_public_path__ + "images/help_v2/masthead-63dcddc912fcd178002566f8fe95d01f.png";